import { render, staticRenderFns } from "./EditWorkplace.vue?vue&type=template&id=1d4daf6b&"
import script from "./EditWorkplace.vue?vue&type=script&lang=ts&"
export * from "./EditWorkplace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports